import React from "react";
import { Text } from "components/common/Text";
import type { MatchDetails } from "../utils";

type MatchDetailsPanelProps = {
  details: MatchDetails;
  homeName: string;
  awayName: string;
};

const buildDetailValue = (value?: string | null) =>
  value && value.trim().length > 0 ? value : "Not available";

const DetailRow = ({
  label,
  value,
}: {
  label: string;
  value?: string | null;
}) => (
  <div className="flex flex-col rounded-lg border border-border/40 bg-gray-900/40 p-2 text-left text-white">
    <Text
      variant="matchDetailsTitle"
      className="uppercase tracking-wide text-white/50"
    >
      {label}
    </Text>
    <Text variant="matchDetailsValue">{buildDetailValue(value)}</Text>
  </div>
);

const MatchDetailsPanel: React.FC<MatchDetailsPanelProps> = ({ details }) => {
  const { league, stadium, weather, tickets, additionalInfo, officials } =
    details;

  const officialsValue =
    officials.length > 0 ? officials.join(", ") : "Not available";

  return (
    <div className="flex h-full w-full flex-col gap-2 overflow-y-auto text-white">
      <div className="grid grid-cols-3 gap-1 sm:grid-cols-2">
        <DetailRow label="League" value={league} />
        <DetailRow label="Officials" value={officialsValue} />
        <DetailRow label="Stadium" value={stadium} />
        <DetailRow label="Weather" value={weather} />
        <DetailRow label="Tickets Sold" value={tickets} />
        <DetailRow label="Additional Info" value={additionalInfo} />
      </div>
    </div>
  );
};

export default MatchDetailsPanel;
